import React from 'react';
import _ from '../../i18n.jsx';
import style from './weight.height.less';
import FormPureComponent  from '../generic.component.jsx';
import SmallInput from '../small.input/small.input.jsx';
import DontKnowBtn from '../dont.know.btn/dont.know.btn.jsx';
import Slider from '../slider/slider.jsx';

const UNKNOWN = 'UNKNOWN';
export default class Weight extends FormPureComponent {
    constructor() {
        super();
        this.onChangePreprocessor = this.onChangePreprocessor.bind(this);
        this.onSliderMove = this.onSliderMove.bind(this);
        this.state = { kilograms: 0, pounds: 0 };
    }
    componentDidMount() {
        const weight = this.props.value;
        if (weight === UNKNOWN) { return; }
        this.setState({
            pounds: Weight.gmToLbs(weight),
            kilograms: Math.round(weight / Weight.GM_IN_KG)
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value && nextProps.value === UNKNOWN) {
            this.setState({ kilograms: 0, pounds: 0 });
        }
    }
    onSliderMove(value) {
        const disabled = this.props.disabled;
        if (disabled) { return; }
        this.setState({
            pounds: value,
            kilograms: Weight.lbsToKg(value)
        });
    }
    static lbsToKg(lbs) { return Math.round(lbs * Weight.LBS_COEFFICIENT) || 0; }
    static kgToLbs(kg) { return Math.round(kg * Weight.KG_COEFFICIENT) || 0; }
    static gmToLbs(gm) { return Math.round(gm / Weight.GM_IN_KG * Weight.KG_COEFFICIENT) || 0; }
    static validateWeight(weight, min, max) {
        const value = parseInt(weight);
        return max >= value && value >= min;
    }
    onChangePreprocessor(name, value) {
        let _value;
        switch (name) {
            case 'kilograms':
                _value = value * Weight.GM_IN_KG;
                this.setState({
                    kilograms: value,
                    pounds: Weight.kgToLbs(value)
                });
                break;
            case 'pounds':
                _value = Math.round(value * Weight.GM_IN_LBS);
                this.setState({
                    pounds: value,
                    kilograms: Weight.lbsToKg(value)
                });
                break;
            case 'slider':
            default:
                _value = Weight.lbsToKg(value) * 1000;
                this.setState({
                    pounds: value,
                    kilograms: Weight.lbsToKg(value)
                });
        }
        this.onChangeHandler(_value);
    }
    render() {
        const { min, max, disabled } = this.props;
        const { pounds, kilograms } = this.state;
        const isCorrectKgs = 0 !== kilograms ? Weight.validateWeight(kilograms, min / Weight.GM_IN_KG, max / Weight.GM_IN_KG) : true;
        const isCorrectLbs = 0 !== pounds ? Weight.validateWeight(pounds, Weight.gmToLbs(min), Weight.gmToLbs(max)) : true;
        const STRINGS = Weight.STRINGS;
        return (
            <div className={style.wrapper}>
                <div className={style.fieldWrapper}>
                    <SmallInput onlyNumbers={true} disabled={disabled} length="3" error={!isCorrectLbs} name="pounds"
                        title={STRINGS.ENGLISH} value={pounds} unit="lbs" onChangeCallback={this.onChangePreprocessor}/>
                    <span className={style.or}>{STRINGS.OR}</span>
                    <SmallInput onlyNumbers={true} disabled={disabled} length="3" error={!isCorrectKgs} name="kilograms"
                        title={STRINGS.METRIC} value={kilograms} unit="kg" onChangeCallback={this.onChangePreprocessor}/>
                </div>
                <Slider sliderMoveCallback={this.onSliderMove} disabled={disabled} error={!isCorrectKgs} name="slider"
                    value={pounds} onChangeCallback={this.onChangePreprocessor} min={Weight.gmToLbs(min)} max={Weight.gmToLbs(max)}/>
                <DontKnowBtn disabled={disabled} onChangeCallback={this.onChangeHandler}
                    wrapperClass={style.dontKnowButtonWrapper}  value={UNKNOWN} checked={UNKNOWN === this.props.value}/>
            </div>
        );
    }
}
Weight.GM_IN_LBS = 453.592;
Weight.GM_IN_KG = 1000;
Weight.LBS_COEFFICIENT = 0.4535924;
Weight.KG_COEFFICIENT = 2.204623;
Weight.defaultProps = {
    value: 0
};
Weight.STRINGS = {
    ENGLISH: _('English system'),
    METRIC: _('Metric system'),
    OR: _('or')
};
